module.exports = __webpack_public_path__ + "static/media/19ESCAP25.09930723.jpg";